import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { api, asArray } from "../../lib/api";
import { Reveal } from "./Reveal";

export const Stars = ({ n = 5, className = "w-4 h-4" }) => (
  <span className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`${className} ${i <= n ? "fill-[var(--brass)] text-[var(--brass)]" : "text-ink/25"}`} />
    ))}
  </span>
);

export const ReviewList = ({ limit, onEmpty }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/reviews").then((r) => setItems(asArray(r))).catch(() => setItems([]));
  }, []);

  if (items === null) return null;
  if (!items.length) return onEmpty || null;
  const list = limit ? items.slice(0, limit) : items;

  return (
    <div data-testid="review-list" className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {list.map((r, i) => (
        <Reveal key={r.id} delay={(i % 2) * 0.1}>
          <figure data-testid={`review-${r.id}`} className="h-full rounded-2xl bg-[#f7f8fa] border border-ink/10 p-7 sm:p-9 flex flex-col">
            <Quote className="w-8 h-8 text-[var(--brass-deep)]" />
            <blockquote className="mt-5 font-serif-i text-xl sm:text-2xl leading-snug text-ink">“{r.message}”</blockquote>
            <figcaption className="mt-auto pt-8 flex items-end justify-between gap-4">
              <span>
                <span className="block font-display font-bold">{r.name}</span>
                <span className="block text-sm text-ink/65">{[r.designation, r.company].filter(Boolean).join(", ")}</span>
              </span>
              <span className="flex flex-col items-end gap-2">
                <Stars n={r.rating} />
                <span className="font-mono-x text-[11px] uppercase text-ink/60">{r.entity_type}</span>
              </span>
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  );
};
